var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "709px",
    height: "709px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.958
    },
    fill: "#fefffe",
    d: "M 90.5,264.5 C 94.1667,264.5 97.8333,264.5 101.5,264.5C 101.5,274.833 101.5,285.167 101.5,295.5C 76.1984,298.48 60.1984,312.147 53.5,336.5C 42.1471,336.832 30.8138,336.499 19.5,335.5C 24.3777,304.252 41.3777,282.418 70.5,270C 77.2081,267.826 83.8748,265.993 90.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.954
    },
    fill: "#fefffe",
    d: "M 113.5,264.5 C 124.833,264.5 136.167,264.5 147.5,264.5C 147.5,288.5 147.5,312.5 147.5,336.5C 136.167,336.5 124.833,336.5 113.5,336.5C 113.5,312.5 113.5,288.5 113.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#fefffe",
    d: "M 249.5,264.5 C 250.833,264.5 252.167,264.5 253.5,264.5C 253.5,272.167 253.5,279.833 253.5,287.5C 239.527,285.964 231.194,291.964 228.5,305.5C 235.833,305.5 243.167,305.5 250.5,305.5C 250.5,312.833 250.5,320.167 250.5,327.5C 243.167,327.5 235.833,327.5 228.5,327.5C 228.5,352.5 228.5,377.5 228.5,402.5C 220.167,402.5 211.833,402.5 203.5,402.5C 203.5,377.5 203.5,352.5 203.5,327.5C 200.5,327.5 197.5,327.5 194.5,327.5C 194.5,320.167 194.5,312.833 194.5,305.5C 197.833,305.5 201.167,305.5 204.5,305.5C 205.137,288.369 213.137,276.203 228.5,269C 235.46,266.643 242.46,265.143 249.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.935
    },
    fill: "#fefffe",
    d: "M 269.5,264.5 C 281.652,265.84 286.152,272.507 283,284.5C 278.874,290.97 273.041,293.137 265.5,291C 257.068,285.688 255.235,278.522 260,269.5C 262.907,267.132 266.074,265.465 269.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.932
    },
    fill: "#fefffe",
    d: "M 672.5,264.5 C 685.25,266.098 689.75,273.098 686,285.5C 680.175,292.07 673.342,293.237 665.5,289C 658.73,281.388 659.063,274.055 666.5,267C 668.611,266.155 670.611,265.322 672.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#fefffe",
    d: "M 329.5,303.5 C 333.5,303.5 337.5,303.5 341.5,303.5C 341.5,310.833 341.5,318.167 341.5,325.5C 330.415,324.951 322.582,329.617 318,339.5C 316.546,360.446 316.046,381.446 316.5,402.5C 308.5,402.5 300.5,402.5 292.5,402.5C 292.333,381.164 292.5,359.831 293,338.5C 296.88,318.119 309.047,306.452 329.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.966
    },
    fill: "#fefffe",
    d: "M 385.5,303.5 C 406.881,301.613 423.714,309.28 436,326.5C 439.198,332.095 441.198,338.095 442,344.5C 442.5,363.83 442.667,383.164 442.5,402.5C 434.5,402.5 426.5,402.5 418.5,402.5C 418.663,400.143 418.497,397.81 418,395.5C 407.182,403.667 395.015,406.5 381.5,404C 358.313,399.147 345.147,384.98 342,361.5C 339.42,328.959 353.92,309.625 385.5,303.5 Z M 384.5,326.5 C 405.84,323.85 417.174,333.183 418.5,354.5C 417.695,371.471 408.862,380.804 392,382.5C 375.18,380.844 366.346,371.511 365.5,354.5C 365.659,340.72 371.992,331.387 384.5,326.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fefffe",
    d: "M 488.5,303.5 C 510.209,300.113 527.042,307.447 539,325.5C 540.937,329.646 542.271,333.979 543,338.5C 543.5,359.831 543.667,381.164 543.5,402.5C 535.5,402.5 527.5,402.5 519.5,402.5C 519.955,381.113 519.455,359.78 518,338.5C 514.386,330.093 507.886,325.76 498.5,325.5C 489.638,325.84 483.138,329.84 479,337.5C 477.544,359.113 477.044,380.78 477.5,402.5C 469.5,402.5 461.5,402.5 453.5,402.5C 453.333,380.831 453.5,359.164 454,337.5C 458.765,319.235 470.265,307.901 488.5,303.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#fefffe",
    d: "M 593.5,303.5 C 614.108,301.083 630.942,307.75 644,323.5C 648.46,330.547 651.127,338.214 652,346.5C 652.667,366.167 652.667,385.833 652,405.5C 647.753,426.08 635.253,438.247 614.5,442C 591.608,445.539 572.608,438.706 557.5,421.5C 563.715,416.472 570.215,411.806 577,407.5C 588.974,421.033 603.141,423.867 619.5,416C 626.254,410.409 629.087,403.242 628,394.5C 622.26,399.953 615.426,403.119 607.5,404C 580.154,406.755 561.988,395.255 553,369.5C 549.478,353.713 551.478,338.713 559,324.5C 567.529,312.491 579.029,305.491 593.5,303.5 Z M 598.5,325.5 C 617.398,325.564 627.398,335.064 628.5,354C 625.71,377.064 613.043,385.73 590.5,380C 580.096,374.532 575.096,365.866 575.5,354C 575.718,338.298 583.385,328.798 598.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#fefffe",
    d: "M 258.5,305.5 C 266.5,305.5 274.5,305.5 282.5,305.5C 282.5,337.833 282.5,370.167 282.5,402.5C 274.5,402.5 266.5,402.5 258.5,402.5C 258.5,370.167 258.5,337.833 258.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#fefffe",
    d: "M 662.5,305.5 C 670.5,305.5 678.5,305.5 686.5,305.5C 686.5,337.833 686.5,370.167 686.5,402.5C 678.5,402.5 670.5,402.5 662.5,402.5C 662.5,370.167 662.5,337.833 662.5,305.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.961
    },
    fill: "#fefffe",
    d: "M 95.5,307.5 C 97.7925,307.244 99.9592,307.577 102,308.5C 115.458,344.251 103.958,367.251 67.5,377.5C 65.3643,376.577 64.1976,374.911 64,372.5C 57.8649,354.742 59.8649,338.075 70,322.5C 77.2621,315.29 85.7621,310.29 95.5,307.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.96
    },
    fill: "#fefffe",
    d: "M 19.5,350.5 C 30.8333,350.5 42.1667,350.5 53.5,350.5C 53.5,374.5 53.5,398.5 53.5,422.5C 42.1667,422.5 30.8333,422.5 19.5,422.5C 19.5,398.5 19.5,374.5 19.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.963
    },
    fill: "#fefffe",
    d: "M 113.5,350.5 C 124.5,350.5 135.5,350.5 146.5,350.5C 142.548,383.288 125.214,405.788 94.5,418C 85.1239,421.375 75.4573,422.875 65.5,422.5C 65.5,412.167 65.5,401.833 65.5,391.5C 84.5756,389.72 99.0756,380.72 109,364.5C 111.368,360.1 112.868,355.434 113.5,350.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.10eacb67ae669f5a293053fdc689ffbb.svg";
export { ForwardRef as ReactComponent };